import { useLanguage } from "@/iti-core-react/hooks/useLanguage";
import { AutomationDto } from "@/shared/dtos/automation-dto";
import { usePaginationChangeHandlers } from "@/shared/hooks/usePaginationChangeHandlers";
import Pagination from "devextreme-react/pagination";
import AutomationCard from "../AutomationCard/AutomationCard";
import "./AutomationCardList.scss";

interface Props {
	automations: AutomationDto[];
	onPlay: (a: AutomationDto) => Promise<void>;
	onPause: (a: AutomationDto) => Promise<void>;
	onStop: (a: AutomationDto) => Promise<void>;
	onResume: (a: AutomationDto) => Promise<void>;
	onViewDetail?: (a: AutomationDto) => void;
	pageSize: number;
	pageIndex: number;
	totalItemCount: number;
	onPageIndexChanged: (newIndex: number) => void;
	onPageSizeChanged: (newPageSize: number) => void;
}

export default function AutomationCardList({
	automations,
	onPlay,
	onPause,
	onStop,
	onResume,
	onViewDetail,
	pageSize,
	pageIndex,
	totalItemCount,
	onPageIndexChanged,
	onPageSizeChanged,
}: Props) {
	const { t } = useLanguage();
	const PAGE_SIZES = [12, 24, 36];
	const { handlePageIndexChange, handlePageSizeChange } =
		usePaginationChangeHandlers({
			onPageIndexChange: onPageIndexChanged,
			onPageSizeChange: onPageSizeChanged,
		});

	if (!Array.isArray(automations) || automations.length === 0) {
		return (
			<div className="catalogue-empty">
				<p>{t("catalogue.no-results")}</p>
			</div>
		);
	}

	return (
		<div className="catalogue-container">
			<div className="catalogue-grid">
				{automations.map((a) => (
					<AutomationCard
						key={a.sessionId}
						automation={a}
						onPlay={async () => onPlay(a)}
						onPause={async () => onPause(a)}
						onStop={async () => onStop(a)}
						onResume={async () => onResume(a)}
						onViewDetail={() => onViewDetail?.(a)}
					/>
				))}
			</div>

			{totalItemCount > 0 && (
				<div className="automation-pagination">
					<Pagination
						elementAttr={{ class: "automation-pagination-grid" }}
						showInfo={true}
						showNavigationButtons={true}
						allowedPageSizes={PAGE_SIZES}
						itemCount={totalItemCount}
						pageIndex={pageIndex}
						pageSize={pageSize}
						activeStateEnabled={true}
						onPageIndexChange={handlePageIndexChange}
						onPageSizeChange={handlePageSizeChange}
					/>
				</div>
			)}
		</div>
	);
}
